import { render, staticRenderFns } from "./subOrder.vue?vue&type=template&id=073f4790&scoped=true&"
import script from "./subOrder.vue?vue&type=script&lang=js&"
export * from "./subOrder.vue?vue&type=script&lang=js&"
import style0 from "./subOrder.vue?vue&type=style&index=0&id=073f4790&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073f4790",
  null
  
)

export default component.exports